import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-border py-12">
    <div className="container flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex flex-col gap-3">
        <Logo />
        <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          Roba el fuego · Devuélvelo al mundo
        </p>
      </div>
      <div className="text-xs text-muted-foreground font-mono-tech">
        © {new Date().getFullYear()} Prometheus Lab AI · v0.1 · Encendido
      </div>
    </div>
  </footer>
);